import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PageHeader() {
  const { pathname } = useLocation();
  const onCommunity = pathname.startsWith("/community") || pathname === "/living-in-lagoon-city";
  return (
    <header data-testid="page-header" className="sticky top-0 z-40 bg-[#0D0B0E]/85 backdrop-blur-xl border-b border-[#E890A7]/10">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link data-testid="page-header-home" to="/" className="flex items-center gap-3 group">
          <span className="bg-white/95 rounded-full px-3 py-1.5">
            <img src="/assets/joselle-logo.png" alt="Joselle Alves Broker" className="h-6 w-auto" />
          </span>
          <span className="hidden sm:block font-mono text-[10px] tracking-[0.3em] uppercase text-[#E890A7]/80">
            Lagoon City
          </span>
        </Link>
        <nav className="flex items-center gap-5 text-sm">
          <Link data-testid="page-header-properties" to="/#properties" className="text-slate-300 hover:text-[#F2A7BA] transition-colors">Waterfront Homes for Sale</Link>
          {!onCommunity && (
            <Link data-testid="page-header-guide" to="/community/neighbourhood" className="text-slate-300 hover:text-[#F2A7BA] transition-colors">Community</Link>
          )}
        </nav>
      </div>
    </header>
  );
}

export function BackLink({ to, label }) {
  return (
    <Link
      data-testid="back-link"
      to={to}
      className="inline-flex items-center gap-2 text-sm text-[#F2A7BA] hover:text-[#E890A7] transition-colors"
    >
      <ArrowLeft size={16} /> {label}
    </Link>
  );
}
